<template>
  <div class="ContentTabs__container">
    <div v-if="!isMobile" class="ContentTabs__tabs">
      <a
        v-for="(tab, index) in config.length"
        :key="`${index}-aKey`"
        v-on:click="updateTabs(tab)"
        :class="[
          'ContentTabs__tab',
          { ContentTabs__active: activeTab === tab },
          { ContentTabs__disabled: config[index].disabled }
        ]"
      >
        {{ config[index].title }}
      </a>
      <div
        :class="[
          'ContentTabs__content',
          { ContentTabs__activeContent: activeTab === tab }
        ]"
        v-for="(tab, index) in config.length"
        :key="`${index}-bKey`"
      >
        <div
          v-if="contentLoaded === false"
          class="ContentTabs__preloadFilter"
        ></div>
        <div
          v-if="activeTab === tab && !config[index].withFilter"
          v-html="content"
        ></div>
        <div v-if="activeTab === tab && config[index].withFilter">
          <BranchList :config="listConfig" />
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="ContentTabs__tabs ContentTabs__mobile">
      <div v-for="(tab, index) in config.length" :key="`${index}-cKey`">
        <a
          v-if="!config[index].disabled"
          v-on:click="updateTabs(tab)"
          :class="[
            'ContentTabs__tab',
            { ContentTabs__active: activeTab === tab && mobileHidden !== tab }
          ]"
        >
          {{ config[index].title }}
        </a>
        <div
          :class="[
            'ContentTabs__content',
            { ContentTabs__activeContent: activeTab === tab && !isMobile },
            {
              ContentTabs__activeContent:
                activeTab === tab && isMobile && mobileHidden !== tab
            }
          ]"
        >
          <div class="preloadFilter" v-if="contentLoaded === false">
            <Loading />
          </div>
          <div
            v-if="activeTab === tab && !config[index].withFilter"
            v-html="content"
          ></div>
          <div v-if="activeTab === tab && config[index].withFilter">
            <BranchList :config="listConfig" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BranchList from "../BranchList/BranchList";
import Loading from "../Loading/Loading";

export default {
  name: "BranchDetailTabs",
  components: {
    BranchList,
    Loading
  },
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isMobile: false,
      activeTab: null,
      mobileHidden: null,
      content: null,
      contentLoaded: false,
      activeTabPreselected: false,
      listConfig: ""
    };
  },
  methods: {
    checkScreenSize() {
      window.innerWidth < 780
        ? (this.isMobile = true)
        : (this.isMobile = false);
    },
    updateTabs(tab) {
      const elm = event.currentTarget;
      if (!elm.classList.contains("ContentTabs__disabled")) {
        this.contentLoaded = false;
        if (this.config[tab - 1].url) {
          this.getContentFromUrl(this.config[tab - 1].url);
          this.content = "";
        } else if (this.config[tab - 1].id) {
          this.getContentFromId(this.config[tab - 1].id);
        } else if (this.config[tab - 1].withFilter) {
          this.listConfig = this.config[tab - 1].listConfig;
          this.contentLoaded = true;
        } else {
          this.content = null;
        }
        if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab !== this.mobileHidden
        ) {
          this.mobileHidden = tab;
        } else if (
          this.isMobile &&
          this.activeTab === tab &&
          this.activeTab === this.mobileHidden
        ) {
          this.mobileHidden = null;
        } else if (this.isMobile && this.activeTab !== tab) {
          this.mobileHidden = null;
          this.activeTab = tab;
        } else {
          this.activeTab = tab;
        }
      }
    },
    getContentFromId(id) {
      const html = document.getElementById(id);
      if (html) {
        this.content = html.innerHTML;
        this.contentLoaded = true;
      } else {
        this.content = null;
        this.contentLoaded = false;
      }
    },
    getContentFromUrl(url) {
      axios
        .get(url)
        .then(
          response => (
            (this.content = response.data), (this.contentLoaded = true)
          )
        )
        .catch(
          error => (
            // eslint-disable-next-line no-console
            console.log(error),
            (this.content = null),
            (this.contentLoaded = false)
          )
        );
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
	const queries = window.location.search.substring(1).split("&");
    let queryStringTabId = null;
    if (queries) {
      for (const query of queries) {
        if (query.includes("tab")) {
          queryStringTabId = query.split("=")[1];
        }
      }
    }
	
    for (const [index, tab] of this.config.entries()) {
      if (
        (queryStringTabId && queryStringTabId == index + 1 && !tab.disabled) ||
        (tab.active && !tab.disabled)
      ) {
        this.activeTab = index + 1;
        this.activeTabPreselected = true;
        if (tab.url) {
          this.getContentFromUrl(tab.url);
        } else if (tab.id) {
          this.getContentFromId(tab.id);
        } else if (tab.withFilter) {
          this.listConfig = tab.listConfig;
          this.contentLoaded = true;
        }
      }
    }
    if (!this.activeTabPreselected) {
      this.activeTab = 1;
      if (this.config[0].url) {
        this.getContentFromUrl(this.config[0].url);
      } else if (this.config[0].id) {
        this.getContentFromId(this.config[0].id);
      } else if (this.config[0].withFilter) {
        this.listConfig = this.config[0].listConfig;
        this.contentLoaded = true;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  }
};
</script>
